export const getTranslationErrorId = (codeError: string) => {
  return `general.firebase.${codeError}`;
};
